var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.062 9.778c-.067-.002-.129-.034-.168-.087L5.262 7.763c-.126-.184-.35-.284-.577-.255-.227.028-.418.179-.491.389-.074.21-.018.441.144.598l1.626 1.957c.247.295.61.478 1.002.505h.12c.351 0 .69-.125.954-.349l9.156-7.85c.172-.134.254-.348.214-.558-.04-.21-.197-.382-.407-.447-.21-.065-.44-.014-.599.134L7.242 9.72c-.048.044-.114.065-.18.058z",
    transform: "translate(-92 -475) translate(49 128) translate(43 347)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.83 4.419c-.163-.279-.528-.378-.816-.22-.286.159-.385.511-.222.789 2.016 3.38 1.037 7.69-2.258 9.94-3.294 2.25-7.818 1.7-10.434-1.27-2.616-2.97-2.461-7.38.357-10.172C6.275.695 10.827.442 13.956 2.903c.123.098.282.145.44.13.16-.016.305-.091.406-.211.207-.247.17-.61-.084-.813-3.591-2.86-8.843-2.601-12.115.597-3.273 3.2-3.487 8.284-.495 11.73 2.991 3.447 8.204 4.12 12.024 1.552 3.82-2.568 4.99-7.53 2.698-11.446v-.023z",
    transform: "translate(-92 -475) translate(49 128) translate(43 347)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckList);
export default __webpack_public_path__ + "static/media/check-list.8d85d487.svg";
export { ForwardRef as ReactComponent };